import axios from 'lib/apiClient';

export const checkEligibility = (number) =>
  axios.post('API/1_0/getHostedPhoneEligibility.php', { phone_number: number });

export const requestHost = (payload) =>
  axios.post('API/1_0/hostedNumber.php', payload);

export const getHostedNumbers = () =>
  axios.get('API/1_0/hostedNumber.php', {
    params: { completed: 0 },
  });

export const deleteHostedNumber = (hash) =>
  axios.delete('API/1_0/hostedNumber.php', {
    params: { hash },
  });
